import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { UserRole } from '../../schema/user';

interface UserRoleFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
}

const UserRoleFromInput: React.FC<UserRoleFromInputProps> = ({
  required,
  value,
  onChange
}: UserRoleFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [userRoleList, setUserRoleList] = useState<UserRole[]>([]);
  const [selectedValue, setSelectedValue] = useState<UserRole | null>(null);

  useEffect(() => {
    if (value != null) {
      const userRole = userRoleList.find((data) => data.id == value);
      if (userRole) {
        setSelectedValue(userRole);
        return;
      }
      api.get<UserRole>(`/user_role/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setUserRoleList([data]);
      });
    } else {
      api.get<UserRole[]>(`/user_role`).then((res) => {
        const { data } = res;
        setUserRoleList(data);
      });

      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('name', searchKeyword);
        // searchParams.set('limit', '10');

        api.get<UserRole[]>(`/user_role`, { params: searchParams }).then((res) => {
          const { data } = res;
          setUserRoleList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={userRoleList}
      getOptionLabel={(option) => (option?.role_description ? option.role_description : '')}
      renderInput={(params) => (
        <TextField {...params} label="User Role" required={required} placeholder="User Role" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue) => {
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default UserRoleFromInput;
